import React from 'react';

export default function Content({ children }) {
    return <section className="content">{children}</section>;
}
